<template>
  <Modal
    v-model="_value"
    width="500"
    title="添加车辆所有人信息"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <Form ref="loginForm" :model="vehicleOwnerInfo" :rules="rules" >
      <FormItem prop="name">
        <Input v-model="vehicleOwnerInfo.name" placeholder="请输入车辆所有人名称">
        </Input>
      </FormItem>
      <FormItem prop="phoneNum">
        <Input v-model="vehicleOwnerInfo.phoneNum" placeholder="请输入联系电话">
        </Input>
      </FormItem>
      <FormItem prop="address">
        <Input v-model="vehicleOwnerInfo.address" placeholder="请输入联系地址">
        </Input>
      </FormItem>
      <FormItem prop="remark">
        <Input type="textarea" v-model="vehicleOwnerInfo.remark" placeholder="备注">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'AddVehicleOwnerInfoModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    nameRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '车辆所有人名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {
      vehicleOwnerInfo: {
        name: null,
        phoneNum: null,
        address: null,
        remark: null
      }
    }
  },
  methods: {
    ...mapActions([
      'VehicleOwnerInfoServ_AddObj'
    ]),
    onOk () {
      this.$Modal.confirm({
        title: '添加车辆所有人信息',
        content: '<p>是否确认添加车辆所有人信息</p>',
        onOk: () => {
          store.dispatch('VehicleOwnerInfoServ_AddObj', { params: this.vehicleOwnerInfo }).then(() => {
            this.$Message.success('添加车辆所有人信息成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.vehicleOwnerInfo.name = null
        this.vehicleOwnerInfo.phoneNum = null
        this.vehicleOwnerInfo.address = null
        this.vehicleOwnerInfo.remark = null
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        name: this.nameRules
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
